/** FSD §3.4.1.1 FR-FC-001 classroom rooms for eTS-3 and eTS-5. */
export const ETS35_CLASSROOM_FREE_TEXT = "free_text";

const AA_ROOMS = [
	"AA ROOM 101",
	"AA ROOM 102",
	"AA ROOM 103",
	"AA ROOM 104",
	"AA ROOM 201",
	"AA ROOM 202",
	"AA ROOM 203",
	"AA ROOM 204",
	"AA ROOM 301",
	"AA ROOM 302",
	"AA ROOM 303",
	"AA ROOM 304",
];

export const ETS35_CLASSROOMS_BY_AOC: Record<string, string[]> = {
	maa: ["REDQ", "CAE KL"],
	aax: ["REDQ", "CAE KL"],
	tax: ["NARITA", "INCHEON", "OSAKA", ...AA_ROOMS],
	taa: [...AA_ROOMS],
	iaa: [
		"THROTTLE",
		"WINGTIP",
		"SHARKLET",
		"TRIM",
		"JOYSTICK",
		"SPOILER",
		"FUSELAGE",
		"NOSEWHEEL",
		"APRON",
		"WINDSHIELD",
		"RUDDER",
	],
	paa: ["SKYLINE", "MINDANAO", "LUZON", "VISAYAS", "KARUNUNGAN", "KAALAMAN", "FINANCE", "CASHIER"],
	aac: ["AAC REDBASE CHAMPA", "AAC REDBASE ROMDOUL", "AAC REDBASE MALICE"],
};

export function classroomsForAoc(aocCode: string | null | undefined): string[] {
	const key = (aocCode ?? "").trim().toLowerCase();
	return ETS35_CLASSROOMS_BY_AOC[key] ?? [];
}
